export default __webpack_public_path__ + "static/media/vitor.b1692c2f.jpg";